import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { firebase } from '@firebase/app';
import { VenueMap } from '../models/venue-detail'
import { ContentsMandatory } from '../models/contents-mandatory';
import { promise } from 'selenium-webdriver';

@Injectable()
export class VenueDetailService {

  constructor(private db: AngularFireDatabase,private utilityService:UtilityService) { }

  getVenue(id: string):Observable<any> {
    if(id) {
      let data :AngularFireObject<any> =  this.db.object(Constants.EVENT_URL+'/'+id+Constants.PREDERENCES_URL+Constants.VENUE_URL);
      return  data.valueChanges();
    }
  }

  getImageUrl(eventId: string, venueId:string):Observable<any> {
    if(venueId) {
      let data :AngularFireObject<any> =  this.db.object(Constants.EVENT_URL+'/'+eventId+Constants.Contents_Mandatory_URL+'/'+venueId);
      return  data.valueChanges();
    }
  }

  uploadFile(eventId:string,file: File):any {
    let storageRef = firebase.storage().ref();
    let path = eventId+Constants.Contents_Mandatory_URL+Constants.STORAGE_VENUE_URL;
    console.log(path);
    return storageRef.child(`${path}/${file.name}`).put(file);
  }

  addContentMandatory(contentsMandatory:ContentsMandatory):string {
    return this.db.list(Constants.EVENT_URL+'/'+contentsMandatory.eventId+Constants.Contents_Mandatory_URL)
    .push(contentsMandatory).key;
  }

  updateVenue(eventId: string, venueData: VenueMap):Promise<any> {
    return this.db.object(Constants.EVENT_URL+'/'+eventId+Constants.PREDERENCES_URL+Constants.VENUE_URL).update(venueData);
  }

}



// WEBPACK FOOTER //
// /app/src/app/core/services/venue-detail.service.ts